module.exports = __webpack_public_path__ + "static/media/ฉลู.03bcba77.jpg";